document.addEventListener('DOMContentLoaded', function() {

    // Custom variant data and files swatches
    let variantPicker = document.querySelector('.product-info__variant-picker');
    if (variantPicker) {
        let variantOptions = variantPicker.querySelectorAll('label.block-swatch');
        variantOptions.forEach(function(variantOption){
            let textCheck = variantOption.querySelector('span').textContent;
            variantOption.addEventListener('click', function(){
                let dataLists = document.querySelectorAll('.variant-documents');
                if (dataLists.length > 0) {
                  dataLists.forEach(function(dataList){
                    let dataCheck = dataList.getAttribute('id');
                    dataList.classList.remove('active');
                    if (textCheck == dataCheck) {
                        dataList.classList.add('active');
                    }
                })
                }
            })
        })
    }

    document.addEventListener('variant:change', function() {
      let href = window.location.href;
      let variantId = href.split('=').pop();
      let merchants = document.querySelectorAll('.custom-merchant-price');
      let merchantTitle = document.querySelector('.merchant-title');
      let hasActiveVariant = false;

      // Toggle custom-variant-desc classes
      let descriptions = document.querySelectorAll('.custom-variant-desc');
      descriptions.forEach(function(description) {
          if (description.getAttribute('data-id') == variantId) {
              description.classList.add('active');
          } else {
              description.classList.remove('active');
          }
      });

      if (merchants.length > 0) {
      merchants.forEach(function(merchant){
        merchant.classList.remove('active-variant');
        if (merchant.getAttribute('data-id') == variantId) {
        merchant.classList.add('active-variant');
        hasActiveVariant = true;
        setTimeout(() => {
          updateLastActive();
        }, 100);
        }
      });
      }

      if (merchantTitle) {
      merchantTitle.style.display = hasActiveVariant ? 'block' : 'none';
      }
    });

    function updateLastActive() {
       
      document.querySelectorAll('.custom-merchant-price.active-variant').forEach(el => {
        el.classList.remove('last-active');
      });

      const activeElements = Array.from(document.querySelectorAll('.custom-merchant-price.active-variant'));
      if (activeElements.length > 0) {
        activeElements[activeElements.length - 1].classList.add('last-active');
      }
  }

  updateLastActive(); // Initial call

  let points = document.querySelectorAll('.frontpage-points span');
  let currentIndex = 0;

  function showNextPoint() {
    points[currentIndex].classList.remove('active');
    points[currentIndex].classList.add('inactive');
    currentIndex = (currentIndex + 1) % points.length;
    points[currentIndex].classList.remove('inactive');
    points[currentIndex].classList.add('active');
  }

  
  points[currentIndex].classList.add('active');

  
  setInterval(showNextPoint, 3000);

});